import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ReopenedIcon = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M8.66683 4.55554H7.3335V8.55554H11.3335V7.22221H8.66683V4.55554Z'
    fill='#0058AD'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M7.99992 2.66671C5.0544 2.66671 2.66659 5.05452 2.66659 8.00004C2.66659 10.9456 5.0544 13.3334 7.99992 13.3334V14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00004C1.33325 4.31814 4.31802 1.33337 7.99992 1.33337C11.6818 1.33337 14.6666 4.31814 14.6666 8.00004H13.3333C13.3333 5.05452 10.9454 2.66671 7.99992 2.66671Z'
    fill='#0058AD'
  />
  <Path
    d='M13.5839 13.8757V14.6667H10.3092V13.9961L11.8391 12.375C11.9823 12.2101 12.0963 12.0647 12.1809 11.9388C12.2677 11.813 12.3306 11.699 12.3697 11.597C12.4088 11.4929 12.4283 11.3974 12.4283 11.3106C12.4283 11.1695 12.4055 11.0502 12.3599 10.9525C12.3165 10.8549 12.2525 10.78 12.1679 10.7279C12.0833 10.6758 11.9802 10.6498 11.8586 10.6498C11.7284 10.6498 11.6167 10.6834 11.5234 10.7507C11.43 10.818 11.3584 10.9113 11.3085 11.0306C11.2586 11.1478 11.2336 11.2813 11.2336 11.431H10.2115C10.2115 11.1424 10.281 10.8798 10.4198 10.6433C10.5587 10.4046 10.753 10.2147 11.0025 10.0736C11.2521 9.93038 11.544 9.85876 11.8782 9.85876C12.2211 9.85876 12.5086 9.91302 12.7408 10.0215C12.973 10.13 13.1488 10.2852 13.2681 10.487C13.3875 10.6888 13.4472 10.9319 13.4472 11.2162C13.4472 11.3768 13.4211 11.5319 13.3691 11.6817C13.3191 11.8314 13.2464 11.9801 13.151 12.1276C13.0555 12.2752 12.9405 12.426 12.8059 12.5801C12.6714 12.732 12.5195 12.8926 12.3502 13.0619L11.634 13.8757H13.5839Z'
    fill='#0058AD'
  />
</Svg>;

export default ReopenedIcon;
